import { CreditGrantType } from '../types/Credits';
import { CreditSpendLeaderboardQuery, CreditUsageBreakdown } from './CreditSpendLeaderboard';

export const CreditOverviewQuery = CreditSpendLeaderboardQuery;

export type CreditOverviewQuery = CreditSpendLeaderboardQuery;

export type CreditGrantBreakdown = Partial<Record<CreditGrantType, number>>;

export type CreditOverviewDay = {
    date: string;
    spent: number;
    granted: number;
};

export type CreditOverviewResponse = {
    totals: {
        spent: number;
        granted: number;
        purchasedRevenue: number;
        netIssued: number;
    };
    spendByType: CreditUsageBreakdown;
    grantsByType: CreditGrantBreakdown;
    series: CreditOverviewDay[];
};
